export default __webpack_public_path__ + "static/media/region.8c067ea8.svg";